module.exports = __webpack_public_path__ + "img/intro_mock.dc7d569b.png";